import { WAPP_COMMUNICATE_CORE_SEND_ANALYTICS } from '@weblite/wapp-communication-action/core'
import { wappSub } from '$func/subscription'

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_SEND_ANALYTICS,
  ({ payload: { type, data }, meta: { wappId, wisId } }) =>
    analite(type, data, wappId, wisId),
  true,
)
